import React from 'react'
import AntDTooltip from 'antd/lib/tooltip'
import 'antd/lib/tooltip/style/css'

const Tooltip = (props) => {
  return <AntDTooltip {...props} />
}

export default Tooltip
